/**
 * View Tag Feature: JAVASCRIPT
 * @module
 */

var locatorType = require('core/tags').enums.locatorType;

module.exports = function(PluginManager) {
  PluginManager.registerViewTagLocator(locatorType.JAVASCRIPT, require('./code_tag_parser'));
};
